import React from 'react';
import { useStyletron } from 'baseui';

interface ICardItem {
	label: string;
	img?: string;
}

const CardItem: React.FC<ICardItem> = ({ label, img }) => {
	const [css] = useStyletron();

	return (
		<div
			className={css({
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',
				textAlign: 'center'
			})}>
			{img && <img src={img} height='100px' alt='menu-img' />}
			<div
				className={css({
					width: '70%',
					height: '100%'
				})}>
				{label}
			</div>
		</div>
	);
};

export default CardItem;
